<template>
  <div>
    <div class="topWrap">
      <img src="@/assets/img/menuLogo.png" alt="" />
      <span class="menuWhere">{{ menuTitle }}</span>
      <!-- <span class="whoId">{{ loginUserInfo.roles[0].roleName }}</span> -->
      <el-tooltip placement="bottom" class="whoId">
        <div slot="content">
          <p
            class="eitor"
            style="margn-top: 15px; margin-bottom: 15px; cursor: pointer"
            @click="dialogVisible = true"
            v-if="whoLogin !== 1"
          >
            修改密码
          </p>
          <p class="eitor" style="cursor: pointer" @click="loginOut">退出登录</p>
        </div>
        <span>{{ loginUserInfo.nickName }}</span>
      </el-tooltip>
      <span class="couseUseTime" v-if="whoLogin == 3 && loginUserInfo.booleTime"
        >课件使用时间:&nbsp;&nbsp;{{ loginUserInfo.dept.courseUsageTime || "暂无" }}</span
      >
    </div>
    <div class="leftWrap">
      <img src="@/assets/img/logo.png" alt="" class="logoImg" />
      <el-row class="tac">
        <el-col :span="12">
          <el-menu
            class="el-menu-vertical-demo"
            :default-active="activeMenu"
            router
            @select="handleSelect"
          >
            <div v-for="(item, i) in navList" :key="i">
              <el-submenu :index="item.name" v-if="item.second">
                <template slot="title">
                  <img :src="item.icon" alt="" class="manngicon" />
                  <span>{{ item.navItem }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    :index="sec.name"
                    v-for="(sec, j) in item.second"
                    :key="j"
                    @click="chooseMenuChild(sec)"
                    >{{ sec.navItem }}</el-menu-item
                  >
                </el-menu-item-group>
              </el-submenu>
              <el-menu-item v-else :index="item.name">
                <img :src="item.icon" alt="" class="manngicon" />
                <span slot="title">{{ item.navItem }}</span>
              </el-menu-item>
            </div>
          </el-menu>
        </el-col>
      </el-row>
    </div>
    <!-- 更改密码 -->
    <div id="classSetWrapMenu">
      <el-dialog  title="更改密码" :visible.sync="dialogVisible" width="40%">
        <div>
          <el-form ref="form" label-width="100px" hide-req>
            <!-- <el-form-item label="输入原密码">
              <el-input v-model="form.oldPassWord" placeholder="输入原密码"></el-input>
            </el-form-item> -->
            <el-form-item label="输入新密码">
              <el-input
                v-model="form.newPassWord"
                placeholder="输入新密码"
                type="password"
              ></el-input>
            </el-form-item>
            <el-form-item label="再次输入新密码">
              <el-input
                v-model="form.reNewPassWord"
                placeholder="再次输入新密码"
                type="password"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="getResetPwd">提 交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { apiFirstSubjectList, apiResetPwd } from "@/request/api";
import { Toast } from "vant";
export default {
  name: "menuList",
  data() {
    return {
      form: {
        oldPassWord: "",
        newPassWord: "",
        reNewPassWord: "",
      },
      dialogVisible: false,
      navList: [],
      whoLogin: JSON.parse(localStorage.getItem("userInfo")).roles[0].roleId, //登录的身份1超管，2子管理员,3加盟校区，4教师，5加盟校区子管理员,6超级管理员
      loginUserInfo: JSON.parse(localStorage.getItem("userInfo")), //登录用户信息
      menuTitle: localStorage.getItem("menuTitle"),
      // 超级管理员端
      navList1: [
        {
          name: "/pages/welcom1",
          icon: require("@/assets/img/manngIcon1.png"),
          navItem: "首页 ",
        },
        {
          name: "/pages/school1",
          icon: require("@/assets/img/manngIcon1.png"),
          navItem: "加盟校区管理 ",
        },
        {
          name: "/pages/subject1",
          navItem: "科目管理",
          icon: require("@/assets/img/manngIcon7.png"),
        },
        {
          name: "/pages/CoursewareTwo1",
          navItem: "课件管理",
          icon: require("@/assets/img/manngIcon5.png"),
          second: [],
        },
        {
          name: "/pages/teacherBack1",
          navItem: "教师反馈管理 ",
          icon: require("@/assets/img/manngIcon4.png"),
        },
        {
          name: "/pages/Administrator1",
          navItem: "用户管理 ",
          icon: require("@/assets/img/manngIcon5.png"),
        },
        {
          name: "/pages/foundational1",
          navItem: "基础信息配置",
          icon: require("@/assets/img/manngIcon6.png"),
        },
      ],
      // 科目教研员
      navList2: [
        {
          name: "/pages/welcom1",
          icon: require("@/assets/img/manngIcon1.png"),
          navItem: "首页",
        },
        {
          name: "2",
          navItem: "课件管理 ",
          icon: require("@/assets/img/manngIcon2.png"),
          second: [],
        },
        {
          name: "/pages/teacherBack1",
          navItem: "教师反馈管理 ",
          icon: require("@/assets/img/manngIcon4.png"),
        },
      ],
      // 校长
      navList3: [
        {
          name: "/pages/welcom1",
          icon: require("@/assets/img/manngIcon1.png"),
          navItem: "首页 ",
        },
        {
          name: "/pages/Courseware1",
          navItem: "课件列表 ",
          icon: require("@/assets/img/manngIcon5.png"),
          second: [
            { name: "/pages/check1", navItem: "课件审核" },
          ],
        },
        {
          name: "/pages/Administrator1",
          navItem: "用户管理 ",
          icon: require("@/assets/img/manngIcon5.png"),
        }
      ],
      // 教师
      navList4: [
        {
          name: "/pages/welcom1",
          icon: require("@/assets/img/manngIcon1.png"),
          navItem: "首页",
        },
        {
          name: "/pages/Courseware1",
          navItem: "课件列表 ",
          icon: require("@/assets/img/manngIcon5.png"),
          second: [],
        },
        {
          name: "/pages/coursewareLog1",
          navItem: "课件日志 ",
          icon: require("@/assets/img/manngIcon2.png")
         },
         {
          name: "/pages/message1",
          navItem: "消息中心 ",
          icon: require("@/assets/img/manngIcon4.png")
        }
      ],
      // 副校长
      navList5: [
        {
          name: "/pages/welcom1",
          icon: require("@/assets/img/manngIcon1.png"),
          navItem: "首页 ",
        },
        {
          name: "/pages/Courseware1",
          navItem: "课件列表 ",
          icon: require("@/assets/img/manngIcon5.png"),
        },
        {
          name: "/pages/Administrator1",
          navItem: "用户管理 ",
          icon: require("@/assets/img/manngIcon5.png"),
        }
      ],
      // 运营专员
      navList6: [
        {
          name: "/pages/welcom1",
          icon: require("@/assets/img/manngIcon1.png"),
          navItem: "首页 ",
        },
        {
          name: "/pages/school1",
          icon: require("@/assets/img/manngIcon1.png"),
          navItem: "加盟校区管理 ",
        },
        {
          name: "/pages/CoursewareTwo1",
          navItem: "课件管理",
          icon: require("@/assets/img/manngIcon7.png"),
          second: [],
        },
        {
          name: "/pages/Administrator1",
          navItem: "用户管理 ",
          icon: require("@/assets/img/manngIcon5.png"),
        }
      ],
      addAgentMask: false,
      editor: {
        oldPassWord: "",
        newPassWord: "",
        reNewPassWord: "",
      },
      firstSubject: "", //一级科目列表
    };
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      console.log(route, "meta");
      // if set path, the sidebar will highlight the path you set
      return path;
    },
  },
  mounted() {
    this.getFirstSubjectList();
    console.log("whoLogin", JSON.parse(localStorage.getItem("userInfo")));
    if (this.whoLogin == 1) {
      this.navList = this.navList1;
    } else if (this.whoLogin == 3) {
      this.navList = this.navList3;
    } else if (this.whoLogin == 4) {
      this.navList = this.navList4;
    } else if (this.whoLogin == 6) {
      this.navList = this.navList6;
    } else if (this.whoLogin == 2) {
      this.navList = this.navList2;
    } else if (this.whoLogin == 5) {
      this.navList = this.navList5;
    }else {
      this.navList = [];
    }
    console.log("____P", this.navList);
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log("key", key);
      console.log("keyPath", keyPath);
      switch (key) {
        case "/pages/welcom1":
          localStorage.setItem("menuTitle", "首页");
          break;
        case "/pages/school1":
          localStorage.setItem("menuTitle", "加盟校区管理");
          break;
        case "/pages/subject1":
          localStorage.setItem("menuTitle", "科目管理");
          break;
        case "/pages/Courseware1":
          localStorage.setItem("menuTitle", "课件管理");
          break;
        case "/pages/teacherBack1":
          localStorage.setItem("menuTitle", "教师反馈管理");
          break;
        case "/pages/Administrator1":
          localStorage.setItem("menuTitle", "用户管理");
          break;
        case "/pages/foundational1":
          localStorage.setItem("menuTitle", "基础信息配置");
          break;
        case "/pages/coursewareLog1":
          localStorage.setItem("menuTitle", "基础信息配置");
          break;
        case "/pages/message1":
          localStorage.setItem("menuTitle", "消息中心");
          break;
        case "/pages/check1":
          localStorage.setItem("menuTitle", "课件审核");
          break;
        default:
          console.log("菜单标题走了默认");
          break;
      }
    },
    chooseMenuChild(el) {
      localStorage.setItem("jumpSubjectId1", el.name);
      this.$router.push(el.name);
    },
    //退出登录：
    loginOut() {
      this.$router.push("/");
      // if (this.whoLogin == 1 || this.whoLogin == 2 || this.whoLogin == 6) {
      //   this.$router.push("/");
      // } else {
      //   this.$router.push("/");
      // }
    },
    //修改密码
    getResetPwd() {
      if (this.form.newPassWord != this.form.reNewPassWord) {
        this.$message({
          message: "两次输入的密码不一致请重新输入",
          type: "warning",
        });
        return;
      }

      apiResetPwd({
        userId: this.loginUserInfo.userId,
        password: this.form.newPassWord,
      }).then((res) => {
        console.log("res", res);
        this.navList1[3].second = [];
        if (res.code == 200) {
          this.$message({
            message: "密码修改成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.form.newPassWord = "";
          this.form.reNewPassWord = "";
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    //一级科目列表：
    getFirstSubjectList() {
      apiFirstSubjectList({
        pageNum: 1,
        pageSize: 1000000,
      }).then((res) => {
        console.log("res", res);
        this.navList1[3].second = [];
        this.navList4[1].second = [];
        this.navList5[1].second = [];
        this.navList6[2].second = [];
        if (res.code == 200) {
          this.firstSubject = res.rows;
          this.firstSubject.map((item) => {
            var obj = {
              name: "/pages/CoursewareTwo1/" + item.id,
              navItem: "",
              id: "",
            };
            obj.navItem = item.subjectType;
            obj.id = item.id;
            this.navList1[3].second.push(obj);
            this.navList2[1].second.push(obj);
            this.navList4[1].second.push(obj);
            this.navList3[1].second.push(obj);
            this.navList5[1].second.push(obj);
            this.navList6[2].second.push(obj);
          });
          // console.log("一级科目列表", this.firstSubject);
          // console.log("超级管理员的菜单", this.navList6);
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
.navFlex {
  //横向公用的css，less独特的语法
  float: left;
  display: flex;
  justify-content: space-between;
}
.topWrap {
  z-index: 999;
  width: calc(100% - 250px);
  height: 64px;
  line-height: 64px;
  background: #ffffff;
  box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
  font-size: 16px;
  position: fixed;
  right: 0;
  top: 0;
  img {
    width: 20px;
    height: 20px;
    padding-left: 12px;
    float: left;
    margin-top: 22px;
    margin-right: 14px;
  }
  .menuWhere {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
  .couseUseTime {
    font-size: 14px;
    float: right;
    margin-right: 50px;
    color: #333333;
  }
  .whoId {
    float: right;
    margin-right: 22px;
    height: 40px;
  }
}

.leftWrap {
  z-index: 999;
  width: 250px;
  min-height: 100vh;
  background-color: #000000;
  position: fixed;
  left: 0;
  top: 0;
  .logoImg {
    width: 51.56%;
    height: auto;
    margin: 9px 0px 26px 23px;
  }
  .manngicon {
    width: 15px;
    height: 15px;
    padding-right: 3px;
  }
  .el-col-12 {
    width: 251px;
  }
  .el-menu-item {
    font-size: 14px;
    color: #ffffff;
  }
  .el-menu {
    background-color: #000 !important;
  }
  .el-submenu__title {
    font-size: 14px;
    color: #fff;
  }
  // .el-submenu__title {
  //   font-size: 16px;
  // }
  // i:first-of-type {
  //   font-size: 20px !important;
  // }
  // .el-submenu {
  //   i {
  //     font-size: 13px;
  //   }
  //   .el-menu-item {
  //     width: 177px;
  //   }
  // }
  // .el-submenu__title {
  //   margin: 0px -5px;
  // }
}
.el-menu-item.is-active {
  color: #fff;
  background-color: #0098fd;
}
</style>



// WEBPACK FOOTER //
// src/components/menuList.vue